<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer003" style="height:0pt"></div><div class="basic-text-frame" id="_idContainer006">
<p class="structure-next" id="calibre_pb_11"> </p>
<p class="body_quote"> </p>
<p class="body_quote"> </p>
<p class="body_quote">“Step well the path of remembering lit by the stars you have placed, with intention, in the canopy of your own n<span class="nobreak">ight</span><span class="nobreak"> </span><span class="nobreak">sky.”</span></p>
<p class="body_quoteauthor">—Mary Anne<span class="nobreak"> </span><span class="nobreak">Radmacher</span></p>
<p class="body_quote">“A goal is a thing you decide to do. It has a measured result and an ending. An intention is an established motivation that guides you to your goal. It is boundless and only ends whe<span class="nobreak">n you</span><span class="nobreak"> </span><span class="nobreak">do.”</span></p>
<p class="body_quoteauthor">—Mary Anne<span class="nobreak"> </span><span class="nobreak">Radmacher</span></p>
<div class="calibre2" id="calibre_pb_12"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LiveWithIntention_split_004.vue?c6daf4a8